import renderXy from './xySeries';
import {MarkRenderer} from '../types';

export const renderLine: MarkRenderer = (cube, spec, ctx) => ({
    type: 'highcharts',
    options: renderXy('line', cube, spec, ctx),
});

export const renderArea: MarkRenderer = (cube, spec, ctx) => ({
    type: 'highcharts',
    options: renderXy('area', cube, spec, ctx),
});
